import { MapControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { PerspectiveCamera } from 'three'

export class CityControls {
  constructor ({ camera, touchdiv, onLoop, onClean }) {
    this.camera = camera
    this.touchdiv = touchdiv

    this.onClean = onClean
    this.onLoop = onLoop

    this.controls = new MapControls(camera, touchdiv)
    this.controls.enableDamping = true
    this.controls.dampingFactor = 0.05

    this.controls.screenSpacePanning = false

    this.controls.minDistance = 50
    this.controls.maxDistance = 15000000

    // this is for orthographic
    // far away
    this.controls.minZoom = 8.9 / 10
    // zoom into
    this.controls.maxZoom = 25 * 10

    this.controls.panSpeed = 2.3

    this.controls.maxPolarAngle = Math.PI / 2
    this.controls.enableRotate = false

    // init zoom level
    this.setZoom = (value) => {
      this.controls.object.zoom = value
      // this.controls.object.near = -this.controls.object.far
      this.controls.object.updateProjectionMatrix();
    }

    if (camera instanceof PerspectiveCamera) {
      camera.position.set(0, 200, 200)
    } else {
      camera.position.set(-100000, 100000, 100000)
      this.setZoom(2)
    }

    this.run = true
    this.onLoop(() => {
      if (!this.run) {
        return
      }
      this.controls.update()
    })

    this.onClean(() => {
      this.run = false
      this.controls.dispose()
    })

    // return this.controls
  }
}
